import styled from "styled-components"

export const MenuScroller = styled.div`
  padding-right: 16px;
  overflow-y: scroll;
  height: 100%;

  ::-webkit-scrollbar {
    width: 10px;
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    height: 20px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }

  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.5) transparent;

  & {
    -ms-overflow-style: none;
  }
`

export const MenuTitleH3 = styled.div`
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 16px;
`

export const MenuTitleH2 = styled.div`
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 16px;
`
export const MenuTitleH1 = styled.div`
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 16px;
`
